import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_S1_6_12: TStep[] = [
  { pageId: PageId.DOG_BREED_S1_6_12 },
  { pageId: PageId.DOG_AGE_S1_6_12 },
  { pageId: PageId.SHELTER_S1_6_12 },
  { pageId: PageId.COMMANDS_S1_6_12 },
  { pageId: PageId.SUBSCRIPTIONS_S1_6_12 },
  { pageId: PageId.CHAT_UPSELL_S1_6_12 },
  { pageId: PageId.UPSELL_1_S1_6_12 },
  { pageId: PageId.ACCOUNT_NOVE8 },
  { pageId: PageId.DOWNLOAD_S1_6_12 },
]
